import { render, staticRenderFns } from "./AreaDictionary.vue?vue&type=template&id=2bb155e8&scoped=true"
import script from "./AreaDictionary.vue?vue&type=script&lang=js"
export * from "./AreaDictionary.vue?vue&type=script&lang=js"
import style0 from "./AreaDictionary.vue?vue&type=style&index=0&id=2bb155e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb155e8",
  null
  
)

export default component.exports